module.exports = __webpack_public_path__ + "img/modal-banner-desktop.426760f.svg";